import { useState } from "react";
import styled from "styled-components";

import { Utils } from "@tiffin/app-common";
import { DateFormat, IOrderExt, OrderStatus, OrderType } from "@tiffin/core";
import { CustomerOrderModal, OrderStatusBlob } from "@tiffin/components";

import { IonIcon } from "@ionic/react";
import { chevronForwardOutline } from "ionicons/icons";
import moment from "moment";

interface ICustomerOrderCardProps {
  className?: string,
  order: IOrderExt,
  hideViewStoreBtn?: boolean,
  messageCallback: () => void
}

export const CustomerOrderCard = styled(BaseCustomerOrderCard)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  padding: 20px 20px 20px 10px;

  ion-icon {
    font-size: 1.2em;
  }
  
  .order {
    .store-name {
      font-size: 1em;
      font-weight: 600;
      padding-bottom: 10px;
    }

    .content {
      font-size: 0.75em;
      display: flex;
      flex-direction: column;
      gap: 5px;

      .order-details {
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }
`

export function BaseCustomerOrderCard({className, order, hideViewStoreBtn, messageCallback}: ICustomerOrderCardProps) {

  //Internal states
  const [orderModalOpen, setOrderModalOpen] = useState(false)

  function numberOfItems() {
    let count = 0
    for(let item of order.items) {
      count += item.count
    }
    return count
  }

  const numOfItems = numberOfItems();

  const dateText = () => {
    if(order.status === OrderStatus.Ready && order.orderType === OrderType.Pickup) {
      return 'Order is waiting to be picked up'
    }

    if(order.status === OrderStatus.Completed) {
      if(order.time !== "now") {
        return `${moment(order.date).format("dddd, Do MMM YYYY")} at ${moment(order.time).format('h:mm a')}`
      } else {
        return `${moment(order.date).format("dddd, Do MMM YYYY")}`
      }
    }

    if(order.time === "now") {
      const readyBy = moment(order.orderTimestamp).add(order.preparationTimeInMins, 'minutes')
      if(order.orderType === OrderType.Delivery && order.deliveryInformation) {
        readyBy.add(order.deliveryInformation?.durationSeconds, 'seconds')
      }
      if(order.orderType === OrderType.Pickup) {
        return `Ready to pickup by ${readyBy.format('h:mm a')}`
      } else if(order.orderType === OrderType.Delivery) {
        return `Delivery expected by ${readyBy.format('h:mm a')}`
      } else if(order.orderType === OrderType.DineIn) {
        return `Ready by ${readyBy.format('h:mm a')}`
      }
    } else {
      if(moment(order.date, DateFormat).isSame(moment(), 'day')) {
        return `${order.orderType === OrderType.Pickup ? 'Ready to pickup by ' : 'Delivery expected by ' } ${moment(order.time).format('h:mm a')}`
      } else {
        return `${moment(order.date).format("dddd, Do MMM YYYY")} at ${moment(order.time).format('h:mm a')}`
      }
    }
  }

  return (
    <>
      <div className={className} onClick={() => setOrderModalOpen(true)}>
        <div className="order">
          <div className="store-name">
            {order.tiffinName}
          </div>
          <div className="content">
            <div className="order-details">
              <OrderStatusBlob status={order.status}/>{Utils.OrderCustomerStatusText(order.status, order.orderType, moment(order.date, DateFormat).isSame(moment(), 'day'))} • {numOfItems} {numOfItems === 1 ? 'Item' : 'Items'} • ${(order.total / 100).toFixed(2)}
            </div>
            <span>
              {dateText()}
            </span>
          </div>
        </div>
        <IonIcon icon={chevronForwardOutline} />
      </div>
      <CustomerOrderModal 
        order={order}
        isOpen={orderModalOpen}
        onClose={() => setOrderModalOpen(false)}
        hideViewStoreBtn={hideViewStoreBtn}
        messageCallback={messageCallback}
      />
    </>
  )
}